module.exports = __webpack_public_path__ + "media/icons/pochodzenie@2x-8d275778.png";